export default [
  {
    id: 1,
    startDate: new Date().toISOString().substr(0, 10),
    finishData: new Date().toISOString().substr(0, 10),
    duration: '00:00:36',
    OpSys: 'Android',
    ip: '201.17.123.46',
    device: 'Mobile',
    browser: 'Chrome 85.0.4183.127',
    totalInteractions: '4',
    lastUserMessage: 'Não.'
  },
  {
    id: 2,
    startDate: new Date().toISOString().substr(0, 10),
    finishData: new Date().toISOString().substr(0, 10),
    duration: '00:01:45',
    OpSys: 'Windows',
    ip: '45.234.212.226',
    device: 'Mobile',
    browser: 'Chrome 85.0.4183.102',
    totalInteractions: '5',
    lastUserMessage: 'Outro caso'
  },
  {
    id: 3,
    startDate: new Date().toISOString().substr(0, 10),
    finishData: new Date().toISOString().substr(0, 10),
    duration: '00:02:15',
    OpSys: 'Windows',
    ip: '98.234.562.226',
    device: 'Desktop',
    browser: 'Chrome 85.0.4183.127',
    totalInteractions: '0',
    lastUserMessage: 'Quando se trata só de saída de sócios é necessário fazer a viabilidade e lorem ipsum.'
  }
]
